import createReducer from '../utils/createReducer';
import reviewPageActions from '../actions/reviewPage';
import {isEmpty} from 'lodash';
import {
    checkForIncompleteForm, getDialingCountryCode, getCompanyLocation, isAddressAvailable, getAddressFromUserInfoByType,
    isQstEnabled, isQstEligible
} from '../utils/commonUtil';
import {
    checkReviewModalBtnStatus, isUsSite, isEMEABrandSite, isAuSite, isNzSite, checkReviewVatEditBtnStatus
} from '../utils/validate';
import {getDefaultCountryCode} from '../components/utils/createAccountUtil'
import {BILLING, CONTACT} from "../utils/constants";

const initialState = {};

const actionHandlers = {
    // eslint-disable-next-line complexity
    [reviewPageActions.GET_REVIEW_METADATA_SUCCESS](state, {payload}) {
        const {accountInfo, vatInfo, countryList, vatRegionCodes} = payload.reviewDetails;
        const {firstName, lastName, emailAddress, contact, companyName} = accountInfo.user;
        // Get companyCountryCode from state if not present in accountInfo after account edit modal save button click
        const companyCountryCode = accountInfo.companyCountryCode || state.companyCountryCode;
        const {countryCode, number} = contact && contact.phone ? contact.phone : {};

        let mailingAddress = {};
        let billingAddress = {};
        let userInfoBillingAddress = {};
        if (isAddressAvailable(accountInfo)) {
            const userInfoMailingAddress = getAddressFromUserInfoByType(accountInfo, CONTACT);
            mailingAddress = (userInfoMailingAddress.length > 0) ? userInfoMailingAddress[0] : {};

            userInfoBillingAddress = getAddressFromUserInfoByType(accountInfo, BILLING);
            billingAddress = (userInfoBillingAddress.length > 0) ? userInfoBillingAddress[0] : {};
        }

        const {address1, address2, city, stateProvince, country, postalCode} = mailingAddress;

        const companyLocation = getCompanyLocation(companyCountryCode, countryList);

        const accountDetails = {
            name: `${firstName || '–'}${lastName ? ` ${lastName}` : ''}`,
            primaryEmail: emailAddress,
            primaryPhone: `${countryCode ? `+${countryCode}` : '–'}${number ? ` ${number}` : ''}`,
            companyName: companyName || '–',
            companyLocation: companyLocation || '–',
            mailingAddress: [
                `${address1 || '–'}${address2 ? ` ${address2}` : ''}`,
                `${city || '–'}${stateProvince ? ` ${stateProvince}` : ''}`,
                `${postalCode || '–'}${country ? ` ${country}` : ''}`
            ],
            billingAddress: [
                `${billingAddress.address1 || '–'}${billingAddress.address2 ? ` ${billingAddress.address2}` : ''}`,
                `${billingAddress.city || '–'}${billingAddress.stateProvince ? ` ${billingAddress.stateProvince}` : ''}`,
                `${billingAddress.postalCode || '–'}${billingAddress.country ? ` ${billingAddress.country}` : ''}`
            ]
        };

        let incompleteForm = checkForIncompleteForm(accountDetails);
        let enableVatEditButton = !incompleteForm;
        accountDetails.firstName = firstName || '';
        accountDetails.lastName = lastName || '';
        accountDetails.dialingPhoneCode = countryCode || '';
        accountDetails.phoneNumber = number || '';

        accountDetails.addressLine1Val = address1 || '';
        accountDetails.addressLine2Val = address2 || '';
        accountDetails.cityVal = city || '';
        accountDetails.stateVal = stateProvince || '';
        accountDetails.postalCodeVal = postalCode || '';
        accountDetails.addressCountry = country || '';

        accountDetails.billingAddressLine1Val = billingAddress.address1 || '';
        accountDetails.billingAddressLine2Val = billingAddress.address2 || '';
        accountDetails.billingCityVal = billingAddress.city || '';
        accountDetails.billingStateVal = billingAddress.stateProvince || '';
        accountDetails.billingPostalCodeVal = billingAddress.postalCode || '';
        accountDetails.billingCountry = billingAddress.country || '';

        let vatDetails = {};
        const registrationDetails = {};
        let showRegistrationNumber = false;
        let showVatChoice = false;
        const siteName = payload.siteName;
        const checkVatNumberFormat = vatInfo.vatNumber;
        const checkTaxIdentifierPrefix = checkVatNumberFormat ? checkVatNumberFormat.substring(0, 3) : '';

        if ((!isUsSite(siteName) || (isQstEnabled() && (userInfoBillingAddress.length > 0) && isQstEligible(userInfoBillingAddress)))
            && !isEmpty(vatInfo) && vatInfo.vatNumber && checkTaxIdentifierPrefix !== 'TID') {
            vatDetails = {
                countryCode: vatInfo.countryCode || '–',
                vatNumber: vatInfo.vatNumber || '–',
                vatAddress: [
                    `${vatInfo.address1 || '–'}${vatInfo.address2 ? ` ${vatInfo.address2}` : ''}`,
                    `${vatInfo.city || '–'}${vatInfo.stateProvince ? ` ${vatInfo.stateProvince}` : ''}`,
                    `${vatInfo.postalCode || '–'}${vatInfo.country ? ` ${vatInfo.country}` : ''}`
                ]
            };

            incompleteForm = incompleteForm || checkForIncompleteForm(vatDetails);
            vatDetails.addressLine1Val = vatInfo.address1 || '';
            vatDetails.addressLine2Val = vatInfo.address2 || '';
            vatDetails.cityVal = vatInfo.city || '';
            vatDetails.stateVal = vatInfo.stateProvince || '';
            vatDetails.postalCodeVal = vatInfo.postalCode || '';
            vatDetails.addressCountry = vatInfo.country || '';
            vatDetails.regionCode = vatInfo.regionCode || '–';
        } else if ((!isUsSite(siteName) && !isAuSite(siteName) && !isNzSite(siteName)) ||
                (isQstEnabled() && (userInfoBillingAddress.length > 0) && isQstEligible(userInfoBillingAddress))) {
                showVatChoice = true;
                const {companyRegistration} = accountInfo.ipm;

                if (isEMEABrandSite(siteName)) {
                    // Get registrationNumber from state if not present in accountInfo after VAT edit modal save button click
                    registrationDetails.registrationNumber = companyRegistration || state.registrationNumber;
                    registrationDetails.countryCode = state.vatCountryCode || '_';
                    incompleteForm = incompleteForm || !registrationDetails.registrationNumber;
                    showRegistrationNumber = true;
                } else {
                    incompleteForm = true;
                }
            }

        return {
            ...state,
            accountDetails,
            vatDetails,
            incompleteForm,
            countryList,
            vatRegionCodes,
            showVatChoice,
            registrationDetails,
            showRegistrationNumber,
            companyName,
            companyLocation,
            companyCountryCode,
            enableVatEditButton
        };
    },

    // eslint-disable-next-line complexity
    [reviewPageActions.TOGGLE_EDIT_MODAL](state, {payload}) {
        const {modalType, fieldVal, defaultLocale} = payload;
        const enableAccountModal = false;
        const enableVatModal = false;
        const errorKey = 'ipmob.input.field.required';
        let editModalState = {};

        if (modalType === 'VAT info edit') {
            if (state.showVatChoice) {
                editModalState = {
                    enableAccountModal,
                    enableVatModal: fieldVal,
                    vatCountryCode: state.registrationDetails.countryCode,
                    registrationNumber: !isEmpty(state.registrationDetails) ? state.registrationDetails.registrationNumber : null,
                    registrationNumberChoice: 'No',
                    vatChoice: 'No'
                };
            } else {
                let {
                    countryCode, regionCode, vatNumber, addressLine1Val,
                    addressLine2Val, cityVal, stateVal, postalCodeVal, addressCountry
                } = state.vatDetails;

                countryCode = countryCode.replace('–', '');
                regionCode = regionCode.replace('–', '');
                vatNumber = vatNumber.replace('–', '');

                editModalState = {
                    enableAccountModal,
                    addressCountry,
                    vatNumber,
                    vatCountryCode: countryCode,
                    vatRegionCode: regionCode,
                    addressLine1: addressLine1Val,
                    addressLine2: addressLine2Val,
                    city: cityVal,
                    state: stateVal,
                    postalCode: postalCodeVal,

                    vatCountryCodeError: countryCode ? '' : errorKey,
                    vatNumberError: vatNumber ? '' : errorKey,
                    addressLine1Error: addressLine1Val ? '' : errorKey,
                    cityError: cityVal ? '' : errorKey,
                    stateError: stateVal ? '' : errorKey,
                    postalCodeError: postalCodeVal ? '' : errorKey,
                    addressCountryError: addressCountry ? '' : errorKey,
                    enableVatModal: fieldVal
                };
            }
        } else if (modalType === 'Account info edit') {
            let {companyCountryCode, accountDetails} = state;
            let {
                firstName, lastName, primaryEmail, phoneNumber, dialingPhoneCode, companyName,
                addressLine1Val, addressLine2Val, cityVal, stateVal, postalCodeVal, addressCountry,
                billingCountry, billingAddressLine1Val, billingAddressLine2Val, billingCityVal, billingStateVal, billingPostalCodeVal
            } = accountDetails;

            let dialingCountryCode = getDialingCountryCode(dialingPhoneCode, addressCountry);
            dialingCountryCode = dialingCountryCode || getDefaultCountryCode(defaultLocale);
            companyName = companyName.replace('–', '');

            editModalState = {
                enableVatModal,
                firstName,
                lastName,
                dialingCountryCode,
                phoneNumber,
                addressCountry,
                companyName,
                companyCountryCode,
                emailAddress: primaryEmail,
                addressLine1: addressLine1Val,
                addressLine2: addressLine2Val,
                city: cityVal,
                state: stateVal,
                postalCode: postalCodeVal,
                countryDialingNumber: dialingPhoneCode,

                billingAddressLine1: billingAddressLine1Val,
                billingAddressLine2: billingAddressLine2Val,
                billingCity: billingCityVal,
                billingState: billingStateVal,
                billingPostalCode: billingPostalCodeVal,
                billingCountry,

                firstNameError: firstName ? '' : errorKey,
                lastNameError: lastName ? '' : errorKey,
                phoneNumberError: phoneNumber ? '' : errorKey,
                companyNameError: companyName ? '' : errorKey,
                companyCountryCodeError: companyCountryCode ? '' : errorKey,
                addressLine1Error: addressLine1Val ? '' : errorKey,
                cityError: cityVal ? '' : errorKey,
                stateError: stateVal ? '' : errorKey,
                postalCodeError: postalCodeVal ? '' : errorKey,
                addressCountryError: addressCountry ? '' : errorKey,
                enableAccountModal: fieldVal,

                billingAddressLine1Error: billingAddressLine1Val ? '' : errorKey,
                billingCityError: billingCityVal ? '' : errorKey,
                billingStateError: billingStateVal ? '' : errorKey,
                billingPostalCodeError: billingPostalCodeVal ? '' : errorKey,
                billingCountryError: billingCountry ? '' : errorKey
            };
        }

        if (editModalState.enableVatModal || editModalState.enableAccountModal) {
            editModalState.updateServiceSuccess = false;
            editModalState.editModalServiceError = '';
        }

        return {
            ...state,
            ...editModalState,
        };
    },

    // eslint-disable-next-line complexity
    [reviewPageActions.SET_FIELD](state, {payload}) {
        switch (payload.fieldName) {
            case 'vatCountry': return {
                ...state,
                vatCountryCode: payload.fieldValue,
                vatRegionCode: ''
            };
            case 'vatRegionCode': return {
                ...state,
                vatRegionCode: payload.fieldValue
            };
            case 'vatNumber': return {
                ...state,
                vatNumber: payload.fieldValue
            };
            case 'address1': return {
                ...state,
                addressLine1: payload.fieldValue
            };

            case 'address2': return {
                ...state,
                addressLine2: payload.fieldValue
            };

            case 'city': return {
                ...state,
                city: payload.fieldValue
            };

            case 'stateProvince': return {
                ...state,
                state: payload.fieldValue
            };

            case 'postalCode': return {
                ...state,
                postalCode: payload.fieldValue
            };

            case 'country': return {
                ...state,
                addressCountry: payload.fieldValue,
                state: ''
            };

            case 'firstName': return {
                ...state,
                firstName: payload.fieldValue
            };

            case 'lastName': return {
                ...state,
                lastName: payload.fieldValue
            };

            case 'phoneNumber': return {
                ...state,
                phoneNumber: payload.fieldValue
            };

            case 'companyName': return {
                ...state,
                companyName: payload.fieldValue
            };

            case 'companyCountryCode': return {
                ...state,
                companyCountryCode: payload.fieldValue
            };

            case 'dialingCountryCode': return {
                ...state,
                dialingCountryCode: payload.fieldValue
            };

            case 'countryDialingNumber': return {
                ...state,
                countryDialingNumber: payload.fieldValue
            };

            case 'registrationNumber': return {
                ...state,
                registrationNumber: payload.fieldValue
            };

            case 'vatChoiceYes': return {
                ...state,
                vatChoice: 'Yes',
                registrationNumberChoice: 'No',
                registrationNumber: ''
            };

            case 'vatChoiceNo': return {
                ...state,
                vatChoice: 'No'
            };

            case 'registrationNumberYes': return {
                ...state,
                registrationNumberChoice: 'Yes',
                registrationNumber: ''
            };

            case 'registrationNumberNo': return {
                ...state,
                registrationNumberChoice: 'No',
                registrationNumber: ''
            };

            case 'billing_address1': return {
                ...state,
                billingAddressLine1: payload.fieldValue
            };

            case 'billing_address2': return {
                ...state,
                billingAddressLine2: payload.fieldValue
            };

            case 'billing_city': return {
                ...state,
                billingCity: payload.fieldValue
            };

            case 'billing_stateProvince': return {
                ...state,
                billingState: payload.fieldValue
            };

            case 'billing_postalCode': return {
                ...state,
                billingPostalCode: payload.fieldValue
            };

            case 'billing_country': return {
                ...state,
                billingCountry: payload.fieldValue,
                billingState: ''
            };

            default: return {
                ...state
            };
        }
    },

    [reviewPageActions.SET_FIELD_ERROR](state, {payload}) {
        switch (payload.fieldName) {
            case 'vatCountry': return {
                ...state,
                vatCountryCodeError: payload.msg,
            };
            case 'vatNumber': return {
                ...state,
                vatNumberError: payload.msg
            };
            case 'address1': return {
                ...state,
                addressLine1Error: payload.msg
            };

            case 'city': return {
                ...state,
                cityError: payload.msg
            };

            case 'stateProvince': return {
                ...state,
                stateError: payload.msg
            };

            case 'postalCode': return {
                ...state,
                postalCodeError: payload.msg
            };

            case 'country': return {
                ...state,
                addressCountryError: payload.msg
            };

            case 'firstName': return {
                ...state,
                firstNameError: payload.msg
            };

            case 'lastName': return {
                ...state,
                lastNameError: payload.msg
            };

            case 'phoneNumber': return {
                ...state,
                phoneNumberError: payload.msg
            };

            case 'companyName': return {
                ...state,
                companyNameError: payload.msg
            };

            case 'companyCountryCode': return {
                ...state,
                companyCountryCodeError: payload.msg
            };

            case 'registrationNumber': return {
                ...state,
                registrationNumberError: payload.msg
            };

            case 'billing_address1': return {
                ...state,
                billingAddressLine1Error: payload.msg
            };

            case 'billing_city': return {
                ...state,
                billingCityError: payload.msg
            };

            case 'billing_stateProvince': return {
                ...state,
                billingStateError: payload.msg
            };

            case 'billing_postalCode': return {
                ...state,
                billingPostalCodeError: payload.msg
            };

            case 'billing_country': return {
                ...state,
                billingCountryError: payload.msg
            };

            default: return {
                ...state
            };
        }
    },

    [reviewPageActions.REVIEW_PAGE_SERVICE_ERROR](state, {payload}) {
        return {
            ...state,
            serviceError: payload.errorKey
        };
    },

    [reviewPageActions.EDIT_MODAL_SERVICE_ERROR](state, {payload}) {
        return {
            ...state,
            editModalServiceError: payload.errorKey
        };
    },

    [reviewPageActions.UPDATE_SERVICE_SUCCESS](state, {}) {
        return {
            ...state,
            enableVatModal: false,
            enableAccountModal: false,
            updateServiceSuccess: true
        };
    },

    [reviewPageActions.TOGGLE_REVIEW_MODAL_SAVE_BUTTON](state, {}) {
        const enableSaveButton = checkReviewModalBtnStatus(state);

        return {
            ...state,
            enableSaveButton
        };
    },

    [reviewPageActions.TOGGLE_REVIEW_VAT_EDIT_BUTTON](state, {}) {
        const enableVatEditButton = checkReviewVatEditBtnStatus(state);

        return {
            ...state,
            enableVatEditButton
        };
    },

    [reviewPageActions.SET_REVIEW_MODAL_ADDRESS_CHOICE](state, {payload}) {
        const {
            addressCountry,
            addressLine1,
            addressLine2,
            city,
            postalCode
        } = state;
        const stateProvince = state.state;

        let billingCountry;
        let billingAddressLine1;
        let billingAddressLine2;
        let billingCity;
        let billingState;
        let billingPostalCode;

        if (payload.fieldValue === 'Mailing address') {
            billingCountry = addressCountry;
            billingAddressLine1 = addressLine1;
            billingAddressLine2 = addressLine2;
            billingCity = city;
            billingState = stateProvince;
            billingPostalCode = postalCode;
        }

        return {
            ...state,
            billingCountry,
            billingAddressLine1,
            billingAddressLine2,
            billingCity,
            billingState,
            billingPostalCode,
            addressChoice: payload.fieldValue,
            billingCountryError: '',
            billingAddressLine1Error: '',
            billingCityError: '',
            billingStateError: '',
            billingPostalCodeError: ''
        };
    }
};

export default createReducer(actionHandlers, initialState);
